import React from 'react';
const LOCALE_STORAGE_KEY = 'profile_user_locale';

// Special mapping cases: navigatorLocale to oxygenLocale
const navigatorMapping = {
  'fr-ca': 'fr_CA',
  no: 'nb',
  pt: 'pt_PT',
  'pt-br': 'pt_BR',
  'zh-tw': 'zh_TW',
  'zh-hk': 'zh_HK',
  'zh-cn': 'zh_CN',
  'zh-sg': 'zh_CN',
};
const validOxygenLocales = new Set([
  'cs', 'da', 'de', 'en', 'es', 'fi', 'fr', 'fr_CA', 'hu', 'it', 'ja', 'ko',
  'nb', 'nl', 'pl', 'pt_PT', 'pt_BR', 'ru', 'sv', 'tr', 'zh_CN', 'zh_HK', 'zh_TW',
]);

const getSignedoutUserLocale = () => {
  const storedLocale = localStorage.getItem(LOCALE_STORAGE_KEY);

  if (storedLocale) {
    return storedLocale;
  }
  let browserLocale = window.navigator.language.toLowerCase();
  const oxygenMapping = navigatorMapping[browserLocale];
  if (oxygenMapping) {
    return oxygenMapping; // return the oxygen locale directly
  }
  browserLocale = browserLocale.split('-')[0];
  if (validOxygenLocales.has(browserLocale)) {
    return browserLocale;
  }
  return 'en';
};
export default getSignedoutUserLocale;